import { createContext, useContext, useEffect, useReducer } from "react";

import axios from "../../api/axios";
import { STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities";
import {
  articlesReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/articlesReducer";
import { useActionsArticle } from "./ArticleFormProvider";
import { useNavigate } from "react-router-dom";
const ArticleIndexContext = createContext({});
const ArticleIndexProvider = ({ children }) => {
  const [state, dispatch] = useReducer(articlesReducer, INITIAL_STATE);
  const actionsArticle = useActionsArticle();
  let navigate = useNavigate();
  useEffect(() => {
    axios()
      .get(`inventory/getArticlesCompany`, { params: state.articles.filter })
      .then(({ data }) => {
        dispatch({
          type: types.ARTICLES_LOADED,
          payload: { elements: data.articles, rows: data.rows },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  }, [state.articles.status, state.articles.filter.page]);
  //if change filter we have to reset page to getMovements
  useEffect(() => {
    if (state.articles.filter.page !== 1) {
      dispatch({
        type: types.CHANGE_INPUT_FILTER_ARTICLES,
        payload: { name: "page", value: 1 },
      });
    } else {
      dispatch({
        type: types.RELOAD_ARTICLES_BY_FILTER,
      });
    }
  }, [
    state.articles.filter.name,
    state.articles.filter.reference,
    state.articles.filter.sortBy,
    state.articles.filter.sortDir
  ]);
  const goToArticle = (item_id) => {
    navigate(`/inventory/article/${item_id}`);
  };

  return (
    <ArticleIndexContext.Provider value={[state, dispatch, { goToArticle }]}>
      {children}
    </ArticleIndexContext.Provider>
  );
};
const useArticles = () => useContext(ArticleIndexContext)[0];
const useDispatchArticleIndex = () => useContext(ArticleIndexContext)[1];
const useActionsArticles = () => useContext(ArticleIndexContext)[2];

export {
  ArticleIndexContext,
  useArticles,
  useDispatchArticleIndex,
  useActionsArticles,
};
export default ArticleIndexProvider;
